import { render, staticRenderFns } from "./template.vue?vue&type=template&id=6e25ef8c&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e25ef8c",
  null
  
)

export default component.exports